export const SPOTIFY_OAUTH_SUCCESS_MESSAGE = 'SPOTIFY_OAUTH_SUCCESS_MESSAGE';
export const SPOTIFY_OAUTH_FAIL_MESSAGE = 'SPOTIFY_OAUTH_FAIL_MESSAGE';

export function initiateOAuth({
  locale = 'en',
  onSuccess,
}: {
  locale?: string;
  onSuccess: (e: MessageEvent) => void;
}) {
  window.removeEventListener('message', onSuccess);
  openPopup(`/auth/spotify/account?locale=${locale}`, 'openidconnect');
  window.addEventListener('message', onSuccess);
}

function openPopup(url: string, name: string) {
  const features =
    'toolbar=no, menubar=no, width=600, height=700, top=100, left=100';
  return window.open(url, name, features);
}
